/**
 * Ícone por categoria da Central de Ajuda (regra do projeto: MESMOS ícones do
 * Sidebar, azul #0DAEFF). Compartilhado entre HelpCenterPage e HelpWidget.
 */
import {
  Download, Chrome, Mic, Youtube, Flame, CreditCard, AlertTriangle, FolderOpen, Sparkles,
} from 'lucide-react';

export function categoryIcon(cat) {
  const c = (cat || '').toLowerCase();
  if (c.includes('composer')) return Sparkles;       // Composer (gerador por prompt) = Sparkles (Sidebar)
  if (c.includes('app')) return Download;            // App/Download = Download (Sidebar)
  if (c.includes('extens')) return Chrome;           // Extensão Chrome
  if (c.includes('áudio') || c.includes('audio')) return Mic;
  if (c.includes('cana')) return Youtube;            // Gestão de Canais
  if (c.includes('tend') || c.includes('nicho')) return Flame;
  if (c.includes('assinatura') || c.includes('conta') || c.includes('plano')) return CreditCard;
  if (c.includes('problema') || c.includes('erro')) return AlertTriangle;
  return FolderOpen;
}
